import React from "react";

const BackIcon = ({...props}) => (
  <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.85946 18.5487L9.62332 17.6342C9.87441 17.3173 10 16.9472 10 16.5247C10 16.0935 9.87441 15.7278 9.62332 15.427L4.67404 9.50004L9.62317 3.57316C9.87427 3.27237 9.99986 2.90657 9.99986 2.47554C9.99986 2.05284 9.87427 1.68281 9.62317 1.36587L8.85932 0.463405C8.60148 0.154411 8.29249 0 7.93265 0C7.56609 0 7.2606 0.154582 7.01624 0.463363L0.386921 8.40238C0.129045 8.69518 0 9.06086 0 9.5C0 9.9309 0.12901 10.3009 0.386921 10.6096L7.01624 18.5486C7.26748 18.8495 7.57294 19 7.93265 19C8.28579 19 8.5946 18.8495 8.85946 18.5487Z" fill="currentColor"/>
  </svg>
);

export default BackIcon;